import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  backgroundCheckDisclosureTitle: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__backgroundCheckDisclosureTitle),
  additionalDisclosuresTitle: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosuresTitle),
  authAndReleaseDocumentTitle: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__authAndReleaseDocumentTitle),
}

export const additionalDisclosure = {
  title1: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureTitle1),
  text1_1: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText1_1),
  text1_2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText1_2),
  title2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureTitle2),
  text2_1: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_1),
  text2_2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_2),
  text2_3: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_3),
  text2_4: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_4),
  text2_5: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_5),
  text2_6: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_6),
  text2_7: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_7),
  text2_8: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_8),
  text2_9: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText2_9),
  title3: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureTitle3),
  text3_1: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText3_1),
  text3_2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText3_2),
  title4: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureTitle4),
  // text4_1 is interpolated
  text4_2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureText4_2),
  title5: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureTitle5),
  // text5_1 is interpolated
  title6: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__additionalDisclosureTitle6),
  // text6_1 is interpolated
}

export const authAndReleaseDocument = {
  text1: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__authAndReleaseDocumentText1),
  text2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__authAndReleaseDocumentText2),
  text3: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__authAndReleaseDocumentText3),
  text4: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__authAndReleaseDocumentText4),
}

export const backgroundCheckDisclosure = {
  text1: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__backgroundCheckDisclosureText1),
  text2: () =>
    i18n.t(i18nKeys.documentAcceptanceModal__backgroundCheckDisclosureText2),
}
